import { useEffect, useState } from 'react';
import { redirectToUrl, isValidPhoneNumber } from '../utils/urlUtils';

export const useWhatsappRedirect = (queryParams) => {
  const [error, setError] = useState(null);
  useEffect(() => {
    // Wait until we have actual query parameters
    if (!queryParams || Object.keys(queryParams).length === 0) {
      return;
    }
    const { to, e: message } = queryParams;
    if (!to) {
      setError({
        message: 'No phone number provided'
      });
      return;
    }
    if (!isValidPhoneNumber(to)) {
      setError({
        message: 'Invalid phone number format'
      });
      return;
    }
    if (!message) {
      setError({
        message: 'No message provided'
      });
      return;
    }

    // Clean the phone number (remove spaces, dashes, etc)
    const cleanPhone = to.replace(/[^0-9]/g, '');
    // Encode the message to handle special characters properly
    const encodedMessage = `?text=${encodeURIComponent(message)}`;
    // Construct the WhatsApp URL
    const whatsappUrl = `https://wa.me/${cleanPhone}${encodedMessage}`;
    // Redirect to WhatsApp
    redirectToUrl(whatsappUrl);
  }, [queryParams]);

  return { error };
}
